<template>
  <div class="end-box" :style="{'background-image':`url(${require('@/assets/images/end.jpg')})`}">
    <span>水蕴匠心 技绽人生 丽水技师学院欢迎您!</span>
    <span class="end-span">网站正在维护中……</span>
  </div>
</template>

<script>
export default {
  name: "end",
}
</script>

<style scoped>
.end-box{
  width:100vw;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-size: 50px;
  text-align: center;
  color: rgb(114,173,220);
  padding-top: 50px;
}
  .end-span{
    font-size: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/end.vue